import { MultiSelect } from "react-multi-select-component";
import {Delete, RotateCcw} from "lucide-react";

type MultiselectFilterProps<T extends string|number> = {
    label: string,
    value: { value: T, label: string }[],
    options: { value: T, label: string }[]
    setValue: (values: { value: T, label: string }[]) => void
    className?: string
}

export const MultiselectFilter = <T extends string|number>(props: MultiselectFilterProps<T>) => {
    return (
        <MultiSelect
            className={props.className || ''}
            options={props.options}
            value={props.value}
            onChange={props.setValue}
            labelledBy={props.label}
            ClearIcon={<Delete/>}
            ClearSelectedIcon={<RotateCcw/>}
            overrideStrings={{
                allItemsAreSelected: "Tous",
                noOptions: "Aucune option",
                search: "Recherche",
                selectAll: "Tout sélectionner",
                selectAllFiltered: "Tout sélectionner (filtré)",
                selectSomeItems: "Filtre...",
            }}
        />
    )
}